var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"login-image",style:({ backgroundImage: 'url(' + _vm.backgroundImage + ')' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }